import { Component, inject } from "@angular/core";
import { RiskAssessmentPerOrganizationModel } from "@app/export/shared/models/risk-assessment-per-organization-model";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { StandingdataDataService } from "@app/standingdata/shared/standingdata.service";
import { ModuleType } from "@enums/ModuleType";
import { nameof } from "@methods/jeffs-toolkit";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { ExportBase } from "../export-base";
import { CerrixPromptService } from "./../../../shared/services/cerrix-prompt.service";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { injectTranslation, TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/export/i18n/scope";

@Component({
    selector: "export-risks",
    templateUrl: "./export-risks.component.html",
    styleUrls: ["./export-risks.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [TranslatePipe, FormsModule, MatCheckboxModule]
})
export class ExportRisksComponent extends ExportBase {
    permService = inject(PermissionsService);
    private cerrixPrompt = inject(CerrixPromptService);
    private dataService = inject(StandingdataDataService);
    private _translation = injectTranslation(scope);

    includearchivedlinks = true;

    downloadRiskForImport(): void {
        const extra = `includearchivedlinks=${this.includearchivedlinks}`;
        this.exportDataService.downloadExport(this.ExportType.RiskForImport, extra);
    }

    async exportRiskAssessmentPerOrganization(): Promise<void> {
        await this._translation.ready();
        this.cerrixPrompt
            .prompt({
                height: "fit-content",
                data: {
                    title: this._translation.t("risks.riskAssessmentTitle"),
                    message: this._translation.t("selectOrgsMessage"),

                    fields: [
                        {
                            prettyName: this._translation.t("organizationsField"),
                            fieldName: nameof(
                                (x: RiskAssessmentPerOrganizationModel) => x.organizations
                            ),
                            fieldType: GenericListFieldType.MultiTree,
                            minLength: 1,
                            maxLength: 200,
                            required: true,
                            selfInit: true,
                            getDataMethod: () => {
                                return this.dataService.getOrganizations(ModuleType.ORM);
                            },
                        },
                        {
                            prettyName: this._translation.t("risks.periodField"),
                            fieldName: nameof((x: RiskAssessmentPerOrganizationModel) => x.period),
                            fieldType: GenericListFieldType.SingleSelect,
                            placeholder: this._translation.t("noFilter"),
                            selfInit: true,
                            getDataMethod: () => {
                                return this.dataService.getPeriods(ModuleType.ORM);
                            },
                        },
                    ],
                    confirmButton: {
                        text: this._translation.t("downloadButton"),
                        icon: "fad fa-cloud-download",
                    },
                },
            })
            .toPromise()
            .then((result: RiskAssessmentPerOrganizationModel) => {
                if (!result) {
                    return;
                }

                const stringSections: string[] = [];
                if (result.organizations && result.organizations.length > 0) {
                    stringSections.push("organizations=" + result.organizations.join(";"));
                }

                if (result.period && result.period > 0) {
                    stringSections.push("period=" + result.period);
                }

                const extraString = stringSections.length > 0 ? stringSections.join("&") : "";
                this.download(this.ExportType.RiskAssessmentPerOrganization, extraString);
            });
    }
}
